import React, { useState } from 'react';
import { makeStyles, useTheme  } from '@material-ui/core/styles';
import { Card, CardHeader, CardContent, Avatar, Grid, Typography, Tooltip, IconButton, 
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination 
} from '@material-ui/core/';
import moment from 'moment'
import job1 from '../../../global/imagenes/portal/job.png'
import job2 from '../../../global/imagenes/portal/job-s.png'
import job3 from '../../../global/imagenes/portal/experience.png'
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import TimelineIcon from '@material-ui/icons/Timeline';
import DeleteIcon from '@material-ui/icons/Delete';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import VisibilityIcon from '@material-ui/icons/Visibility';









const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: "100%",
    minHeight: "50px",
    height: "300px",
  },
  image: {
    width: '100px',
    maxWidth: '100px',
    minWidth: '100px',
    height: "100px",
  },
  content_text: {
    padding: "0px 0px 0px 10px",
  },
  content_img: {
    textAlign: 'center',
    height: "150px",
  },
    table: {
        minWidth: 650,
    },
    header: {
        backgroundColor: theme.palette.primary.main,
        '& > th': {
            color: theme.palette.common.white,
            fontWeight: 'bold',
        },
    },
    avatar: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    rowActionIcons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    hover_delete_icon: {
        '&:hover': {
            color: theme.palette.error.main,
        },
    },
}));


export function ProcesoActivo({ titulo, fecha, descripcion, estado, handleclickdelete, data }) {
  let fecha_r = moment(fecha).format('YYYY-MM-DD, h:mm a');
  const classes = useStyles();
  
  const random = () => {
    let rnd = Math.floor((Math.random()*3))
    let img = [job1, job2, job3]
    return img[rnd]
  }

  const obtenerColor = (codigo) => {
    let color = 'white';
    const colores = {
      'Por_Env': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
      'Por_Rev': { 'backgroundColor': '#ffc107', color },
      'Por_Ace': { 'backgroundColor': '#0d47a1', color },
    }
    return (colores[codigo])
  }

  const handleclickdeleteWrapper = React.useCallback(
    (e) => {
      handleclickdelete(e, data.id);
    },
    [handleclickdelete, data.id]
  );

  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={<Avatar aria-label="recipe" style={obtenerColor(estado.codigo)}></Avatar>}
        title={titulo}
        subheader={fecha_r}
        action={
          ['Por_Acep', 'Por_Proc'].includes(data.estado_proceso.codigo) && <Tooltip title='Cancelar Solicitud'>
            <IconButton className={classes.hover_delete_icon} aria-label="cancel"
              onClick={handleclickdeleteWrapper}>
              <BlockIcon />
            </IconButton>
          </Tooltip>
        }
      />
      <CardContent>
        <Grid container direction={'row'} justifyContent={'center'}>
          <Grid item xs={12} sm={12} md={12} className={classes.content_img}>
            <img src={job1} className={classes.image} alt='Imagen Tipo' />
            <Typography variant="body2" color="textSecondary" component="p" align='justify'>
              {descripcion}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}


const obtenerColor = (codigo) => {
    const colores = {
        'Por_Env': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
        'Por_Rev': { 'backgroundColor': '#ffc107', color: 'white' },
        'Por_Acep': { 'backgroundColor': '#0d47a1', color: 'white' },
        'Por_Cont': { 'backgroundColor': '#0d47a1', color: 'white' },
        'Por_Rech': { 'backgroundColor': '#b71c1c', color: 'white' },
        'Por_Canc': { 'backgroundColor': '#b71c1c', color: 'white' },
        'Por_Em': { 'backgroundColor': '#b71c1c', color: 'white' },

    }
    return colores[codigo] || {};
}


function ProcesoFila({row, handleclickdelete, onFilaClick, handleClickDeleteLogica }){
    const classes = useStyles();
    const theme = useTheme();
    const primerHistorial = row.historial_estados?.[0];
    const fechaFormateada = primerHistorial?.fecha_registro ? moment(primerHistorial.fecha_registro).format('YYYY-MM-DD h:mm a') : '';
    const historial = row?.historial_estados || [];
    const existeEstadoContratado = historial.some(estado => estado.tipo_estado?.nombre === 'Contratado');
    const vacanteFinalizada = row?.vacante?.estado_solicitud?.codigo === "Por_Fin";
    return (
        <TableRow key={row.id} className={classes.tableRow}>
            <TableCell component="th" scope="row">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar className={classes.avatar} style={obtenerColor(row.estado_proceso.codigo)}></Avatar>
                    <Typography variant="body2" style={{ marginLeft: theme.spacing(1) }}>
                        {row.vacante.tipo_oferta && row.vacante.tipo_oferta.codigo === 'Vac_Lab' ? row.vacante.titulo : row.vacante.nombre_cargo}
                    </Typography>
                </div>
            </TableCell>
            <TableCell>{row.vacante.solicitud_de_vacante === "Vacante Confidencial" ? 'Vacante Confidencial' : row.vacante.nombre_empresa}</TableCell>
            <TableCell>{fechaFormateada}</TableCell>
            <TableCell>{row.estado_proceso.codigo === 'Por_Em' ? 'Empresa Cierra Proceso' : row.estado_proceso.codigo === 'Por_Proc' ? 'Postulación enviada' : row.estado_proceso.codigo === 'Por_Acep' ? 'Admitido' : row.estado_proceso.codigo === 'Por_Canc' ? '	Candidato Cancela' : row.estado_proceso.nombre  }</TableCell>
            <TableCell align="center">
                <div className={classes.rowActionIcons}>
                          <Tooltip title="Ver mi Proceso">
                            <IconButton className={classes.hover_delete_icon} aria-label="Mi Proceso" onClick={() => onFilaClick(row.id)}>
                              <VisibilityIcon/>
                            </IconButton>
                          </Tooltip>
                      {['Por_Canc','Por_Rech', 'Por_Em'].includes(row.estado_proceso.codigo) && (
                          <Tooltip title="Eliminar Solicitud">
                            <IconButton className={classes.hover_delete_icon} aria-label="eliminar" onClick={() => handleClickDeleteLogica(row.id)}>
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                      )}
                    {['Por_Acep', 'Por_Proc'].includes(row.estado_proceso.codigo)&& !(vacanteFinalizada && !existeEstadoContratado) && (
                        <Tooltip title='Cancelar Solicitud'>
                            <IconButton className={classes.hover_delete_icon} aria-label="cancel" onClick={(e) => handleclickdelete(e, row.id)}>
                                <BlockIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                    {row.estado_proceso.codigo === 'Vencida' && (
                        <Tooltip title="Proceso finalizado">
                            <IconButton disabled>
                                <CheckCircleOutlineIcon color="action" />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
            </TableCell>
        </TableRow>
    );
}

export function ProcesosTabla({ data, handleclickdelete, onFilaClick, handleClickDeleteLogica }) {
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); 
    };
    
    return (
        <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                    <TableRow className={classes.header}>
                        <TableCell>Título de Vacante</TableCell>
                        <TableCell>Empresa</TableCell>
                        <TableCell>Postulación a oferta</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell align="center">Acciones</TableCell>
                    </TableRow>
                </TableHead>
                {/* <TableBody>
                    {Array.isArray(data) && data.map((row) => (
                        <ProcesoFila key={row.id} row={row} handleclickdelete={handleclickdelete} onFilaClick={onFilaClick} />
                    ))}
                </TableBody> */}
                <TableBody>
                    {Array.isArray(data) &&
                        data.slice()
                            .reverse()
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => (
                                <ProcesoFila 
                                    key={row.id} 
                                    row={row} 
                                    handleclickdelete={handleclickdelete} 
                                    onFilaClick={onFilaClick} 
                                    handleClickDeleteLogica={handleClickDeleteLogica}
                                />
                            ))}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </TableContainer>
    );
}

